// extracted by mini-css-extract-plugin
export default {"category":"create-tag_category__AC6gA"};